<template>
    <div class="d-flex">
        <CCol sm="3" class="side-bar p-0 pr-4">
            <Sidebar
                style="height: calc(100vh - 56px); overflow-y: scroll"
                @updateChartData="updateChartDataHandler"
                @updateSpinner="(newSpinnerVal) => (spinner = newSpinnerVal)"
                :offset="offset"
                @resetFilter="resetFilter"
                :isMultiple="false"
            />
        </CCol>
        <CCol
            sm="9"
            class="px-2"
            style="height: calc(100vh - 56px); overflow-y: scroll"
        >
            <div class="d-flex justify-content-between my-3 align-items-center">
                <div class="d-flex " style="width: -webkit-fill-available" >
                    <CCol>
                        <div class="border bg-white d-flex flex-column">
                            <div
                                class="p-2 px-4 text-center font-weight-bolder m-auto"
                            >
                                AP Spend
                            </div>
                            <div
                                class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative"
                            >
                                {{ this.total_ap_spend }}
                            </div>
                        </div>
                    </CCol>
                    <CCol>
                        <div class="border bg-white d-flex flex-column">
                            <div
                                class="p-2 px-4 text-center font-weight-bolder m-auto"
                            >
                                PO Spend
                            </div>
                            <div
                                class="border-top p-2 text-center font-weight-bolder d-flex justify-content-center position-relative"
                            >
                                {{ this.total_po_spend }}
                            </div>
                        </div>
                    </CCol>

                </div>
                <div class="d-flex">
                    <div class="rounded-lg py-2 m-auto ml-2">
                        <CDropdown
                            color="secondary"
                            :togglerText="
                                statusFilter === 0
                                    ? 'Show All'
                                    : statusFilter === 1
                                    ? 'In Scope'
                                    : 'Out of Scope'
                            "
                        >
                            <CDropdownItem @click="setStatusFilter(0)"
                                >Show All</CDropdownItem
                            >
                            <CDropdownItem @click="setStatusFilter(1)"
                                >In Scope</CDropdownItem
                            >
                            <CDropdownItem @click="setStatusFilter(2)"
                                >Out of Scope</CDropdownItem
                            >
                        </CDropdown>
                    </div>
                    <CButtonGroup class="align-items-center ml-4">
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isPrevPageDisabled"
                            :class="{ selected: isPrevPageDisabled }"
                            @click="moveToPage('FIRST')"
                            class="nextButton"
                        >
                            First
                        </CButton>
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isPrevPageDisabled"
                            :class="{ selected: isPrevPageDisabled }"
                            @click="moveToPage('PREV')"
                            class="nextButton"
                        >
                            Previous</CButton
                        >
                        <small class="h6 m-0 mx-3" style="width: max-content;">{{
                            `${offset + 1} - ${
                                offset + limit > totalVendorCount
                                    ? totalVendorCount
                                    : offset + limit
                            } of ${totalVendorCount}`
                        }}</small
                        ><br />
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isNextPageDisabled"
                            :class="{ selected: isNextPageDisabled }"
                            @click="moveToPage('NEXT')"
                            class="nextButton"
                        >
                            Next
                        </CButton>
                        <CButton
                            color="white"
                            size="sm"
                            :disabled="isNextPageDisabled"
                            :class="{ selected: isNextPageDisabled }"
                            @click="moveToPage('LAST')"
                            class="nextButton"
                        >
                            Last
                        </CButton>
                    </CButtonGroup>
                </div>
            </div>
            <div class="d-flex spacing-2">
                <div style="width: 100%">
                    <CCard>
                        <CCardHeader>List of Vendors</CCardHeader>
                        <CCardBody>
                            <CDataTable
                                class="sticky-header-table"
                                stickyHeader
                                striped
                                :items="poTableData"
                                :fields="AP_PO_SPEND_TABLE_COLUMNS"
                                :column-filter="false"
                                :items-per-page="10"
                            >
                            </CDataTable>
                        </CCardBody>
                        <CCardFooter>
                            <CButton color="primary" @click="addModal = true"
                                >Add Opportunity</CButton
                            >
                        </CCardFooter>
                    </CCard>
                </div>
            </div>
        </CCol>

        <CModal
            title="Select Opportunity Category"
            :show.sync="addModal"
            centered
            fade
            class="addCategoryModal"
            :closeOnBackdrop="false"
        >
            <label :class="submitted && !selectedCategory ? 'text-red' : ''"
                ><strong>Select Opportunity Category</strong></label
            >
            <v-select
                placeholder="Select a opportunity category"
                :options="opportunityList"
                v-model="selectedCategory"
                :multiple="false"
            />
            <br />
            <CButton
                type="submit"
                color="primary"
                class="m-1"
                @click="submitOpportunityCategory"
                :style="{ float: 'right' }"
                >Submit</CButton
            >

            <CButton
                type="submit"
                color="secondary"
                class="m-1"
                @click="addModal = false"
                :style="{ float: 'right' }"
            >
                Cancel</CButton
            >
        </CModal>
        <CElementCover v-if="spinner" :opacity="0.8" style="z-index: 1" />
    </div>
</template>

<script>
import BarChart from "../../components/charts/Barchart";
import PieChart from "../../components/charts/PieChart";
import Sidebar from "../../components/Sidebar/sidebar";
import vSelect from "vue-select";
import _ from "../Utility/utility";
import { mapState, mapMutations } from "vuex";
import { getSelectedClients } from "../../store";
import { storeData } from "../../store";
import gql from "graphql-tag";

export default {
    data() {
        return {
            AP_PO_SPEND_TABLE_COLUMNS: [
                {
                    key: "vendor_source",
                    _style: "min-width: 130px",
                },
                { key: "po", label: "PO" },
                { key: "ap", label: "AP" },
                {
                    key: "mapped_spend",
                    label: "Mapped Spend",
                    _style: "min-width: 80px",
                },
            ],
            offset: 0,
            limit: 10,
            totalVendorCount: 0,
            order: "desc",
            isNextPageDisabled: false,
            isPrevPageDisabled: true,
            apStartDate: "",
            apEndDate: "",
            poStartDate: "",
            poEndDate: "",
            poTableData: [],
            spinner: false,
            addModal: false,
            opportunityList: [],
            selectedCategory: null,
            chartDataBySidebarFilters: {},
            submitted: false,
            total_ap_spend: "0",
            total_po_spend: "0"
        };
    },
    components: {
        Sidebar,
        BarChart,
        PieChart,
        vSelect,
    },
    computed: {
        ...mapState(["statusFilter"]),
        selectedClients() {
            return getSelectedClients();
        },
    },
    watch: {
        async selectedClients() {
            await this.fetchOpportunityList();
        },
        addModal() {
            if (!this.addModal) {
                this.submitted = false;
            }
        },
    },
    methods: {
        ...mapMutations(["setStatusFilter"]),

        async moveToPage(target) {
            switch (target) {
                case "FIRST":
                    this.offset = 0;
                    this.isPrevPageDisabled = true;
                    this.isNextPageDisabled = false;
                    break;
                case "NEXT":
                    this.offset = this.offset + this.limit;
                    this.isPrevPageDisabled = false;
                    if (this.offset + this.limit >= this.totalVendorCount) {
                        this.isNextPageDisabled = true;
                    }
                    break;
                case "PREV":
                    this.offset = this.offset - this.limit;
                    this.isNextPageDisabled = false;
                    if (this.offset - this.limit < 0) {
                        this.isPrevPageDisabled = true;
                    }
                    break;
                case "LAST":
                    const residue = this.totalVendorCount % this.limit;
                    this.offset = this.totalVendorCount - residue;
                    this.isNextPageDisabled = true;
                    this.isPrevPageDisabled = false;
                    break;
                default:
                    break;
            }
        },
        updateChartDataHandler(chartData) {
            this.chartDataBySidebarFilters = chartData;
            this.updateChart();
        },
        updateChart() {
            let result =
                this.chartDataBySidebarFilters
                    .spendmd_db_spend_by_vendor_mapped_aggregate;

            if (result) {
                this.totalVendorCount = result.aggregate.max.vendor_count;

                if (this.offset + this.limit >= this.totalVendorCount) {
                    this.isNextPageDisabled = true;
                } else {
                    this.isNextPageDisabled = false;
                }

                const tempPoTableData = [];
                let total_ap = 0;
                let total_po = 0;
                this.apStartDate = result.aggregate.max.ap_start;
                this.apEndDate = result.aggregate.max.ap_end;
                this.poStartDate = result.aggregate.max.po_start;
                this.poEndDate = result.aggregate.max.po_end;
                result.nodes.forEach((el) => {
                    total_po += _.parseAmountToInt(result.aggregate.max.total_po_spend);
                    total_ap += (_.parseAmountToInt(result.aggregate.max.total_po_spend) +
                                _.parseAmountToInt(result.aggregate.max.total_non_po_spend));
                    tempPoTableData.push({
                        vendor_source: el.vendor_source,
                        po: _.getMoneyFormat(_.parseAmountToInt(el.po_spend)),
                        ap: _.getMoneyFormat(
                            _.parseAmountToInt(el.po_spend) +
                                _.parseAmountToInt(el.non_po_spend)
                        ),
                        mapped_spend: _.getMoneyFormat(
                            _.parseAmountToInt(el.mapped_spend)
                        ),
                    })
                });

                this.poTableData = tempPoTableData;
                this.total_ap_spend = _.getMoneyFormat(total_ap);
                this.total_po_spend = _.getMoneyFormat(total_po);
            }
        },
        resetFilter() {
            this.moveToPage("FIRST");
        },
        async submitOpportunityCategory() {
            if (!this.selectedCategory) {
                this.submitted = true;
                return;
            }
            this.spinner = true;

            const params = {
                clients: this.selectedClients[0],
                prime_categories:
                    this.chartDataBySidebarFilters.prime_categories,
                secondary_categories:
                    this.chartDataBySidebarFilters.secondary_categories,
                selected_opportunity_id: this.selectedCategory.value,
                sub_categories: this.chartDataBySidebarFilters.sub_categories,
                vendors: this.chartDataBySidebarFilters.vendors,
            };

            await this.$apollo
                .mutate({
                    mutation: SPENDMD_DB_ADD_OPPORTUNITY,
                    variables: params,
                })
                .then((res) => {})
                .catch((err) => {
                    console.log(err);
                });

            await this.updateChart();
            this.addModal = false;
            this.spinner = false;
        },
        async fetchOpportunityList() {
            await this.$apollo
                .mutate({
                    mutation: SPENDMD_DB_GET_OPPORTUNITY_LIST,
                    variables: {
                        clients: this.selectedClients,
                    },
                })
                .then((res) => {
                    this.opportunityList = (
                        res.data.spendmd_db_get_opportunity_list || []
                    ).map((item) => ({
                        label: item.opportunity_category,
                        value: item.id,
                    }));
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    async mounted() {
        await this.fetchOpportunityList();
    },
    beforeMount() {
        if (storeData.currentUserDetails.role.name !== "sys_admin") {
            this.$router.push("/404");
        }
    },
};

const SPENDMD_DB_GET_OPPORTUNITY_LIST = gql`
    query ($clients: json) {
        spendmd_db_get_opportunity_list(args: { clients: $clients }) {
            id
            opportunity_category
        }
    }
`;

const SPENDMD_DB_ADD_OPPORTUNITY = gql`
    mutation (
        $clients: uuid
        $prime_categories: json
        $secondary_categories: json
        $selected_opportunity_id: Int
        $sub_categories: json
        $vendors: json
    ) {
        spendmd_db_add_opportunity(
            args: {
                clients: $clients
                prime_categories: $prime_categories
                secondary_categories: $secondary_categories
                sub_categories: $sub_categories
                vendors: $vendors
                selected_opportunity_id: $selected_opportunity_id
            }
        ) {
            id
        }
    }
`;
</script>

<style scoped>
.nextButton {
    padding: 15px 25px;
    margin: auto 2px;
    background-color: white !important;
    color: #1f2621 !important;
}

.selected {
    background-color: #9ca8a9 !important;
    color: #ffffff !important;
}

.sticky-header-table > div {
    height: 100%;
    overflow-y: auto;
    position: inherit;
}

.sticky-header-table table {
    margin-bottom: 0;
}

.sticky-header-table table > thead {
    position: sticky;
    top: 0;
    z-index: 1;
}

.sticky-header-table table > thead > tr > th {
    padding: 0;
    border: none;
    border-bottom: 2px solid;
    border-bottom-color: #d8dbe0;
}

.sticky-header-table table > thead > tr > th > div {
    padding: 12px;
    background-color: white;
}

.sticky-header-table table > thead > tr > th > div.column-filter {
    padding: 8px 0;
    border-bottom: none;
}

.text-red {
    color: red;
}
</style>
